import {
  CheckCircleOutlineRounded,
  CheckCircleRounded,
  CloseRounded,
  PeopleOutlineRounded,
  SearchRounded,
} from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  IconButton,
  SwipeableDrawer,
  TextField,
  Tooltip,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { toast } from 'react-toastify';
import React, {
  MouseEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  ButtonSelect,
  CardDocument,
  CardUser,
  CardUserToShowDocuments,
  Container,
  Dashboard,
  Header,
  ListagemPendencias,
  SearchFilter,
  SectionDocuments,
  SectionFilters,
  SectionSignatures,
  TabButton,
  TabSignatures,
  Typography,
} from './styles';

import PDF from '../../assets/PDFTema.svg';

import { LogsProps } from '../../services/requests/app-logs/types';
import { Subscribers } from '../../services/requests/assinaturas/types';
import { SignersToNotification } from '../../services/requests/docuSign/type';

import { createLogRequest } from '../../services/requests/app-logs/utils';
import { sendNotificationRequest } from '../../services/requests/docuSign/utils';
import {
  getSignaturesByCompanyId,
  getSignaturesById,
  getSignaturesSignedByCompanyId,
  getSignaturesUnsignedByCompanyid,
  getSignaturesUnsignedByDashboard,
  postToSign,
} from '../../services/requests/assinaturas/utils';

import { stringAvatar } from '../../utils/avatarGenerator';
import fileApi from '../../services/requests/arquivos/fileApi';

import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';
import useMinuteStore from '../../store/minute';

import { DrawerToSign } from '../../components/DrawerToSign';
import { InfoCard } from '../../components/InfoCard';
import { ViewerFile } from '../../components/ViewerFile';
import { getMeetingByIdRequest } from '../../services';

export interface ConselheiroProps {
  name: string;
  quantidade: number;
  avatar_url: string;
}

export const Signatures = () => {
  const user = useAuthStore(state => state.user);
  const setMinute = useMinuteStore(state => state.setMinute);
  const minute = useMinuteStore(state => state.minute);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const timerRef = useRef<any>(null);

  const [statusButton, setStatusButton] = useState('pendentes');
  const [stepDrawer, setStepDrawer] = useState('assinaturas');
  const [listagemAssinados, setListagemAssinados] = useState<Subscribers[]>();
  const [listagemPendentes, setListagemPendentes] = useState<Subscribers[]>();
  const [listagemDocsAssinados, setListagemDocsAssinados] = useState<any>();
  const [listagemDocsPendentes, setListagemDocsPendentes] = useState<any>([]);
  const [loadingToSign, setLoadingToSign] = useState(false);
  const [loadingGetSignaturesUnsigned, setLoadingGetSignaturesUnsigned] =
    useState(false);
  const [loadingGetSignaturesSigned, setLoadingGetSignaturesSigned] =
    useState(false);
  const [openDrawerToSign, setOpenDrawerToSign] = useState(false);
  const [openDrawerShowSignatures, setOpenDrawerShowSignatures] =
    useState(false);
  const [listagemConselheirosPendentes, setListagemConselheirosPendentes] =
    useState<ConselheiroProps[]>([]);
  const [loadingGetToDocument, setLoadingGetToDocument] = useState(false);
  const [urlToSign, setUrlToSign] = useState('');
  const [meetingId, setMeetingId] = useState('');
  const [fileId, setFileId] = useState('');
  const [stateControlMinute, setStateControlMinute] = useState(false);
  const [urlToViewer, setUrlToViewer] = useState<any>();
  const [openModalViewer, setOpenModalViewer] = useState(false);
  const [loadingModalViewer, setLoadingModalViewer] = useState(false);
  const [loadingMinuteState, setLoadingMinuteState] = useState(false);
  const [totalSubscriptions, setTotalSubscriptions] = useState();
  const [totalDocsPendents, setTotalDocsPendents] = useState();
  const [searchForSignaturesSigned, setSearchForSignaturesSigned] =
    useState('');
  const [page, setPage] = useState(1);
  const [disabledButton, setDisabledButton] = useState(false);
  const [counselor, setCounselor] = useState<string | null>(null);
  const [isDocumentInBase, setIsDocumentInBase] = useState<boolean | null>(
    null,
  );

  const handleToSign = useCallback(
    async (document: any, event: MouseEvent) => {
      try {
        event.stopPropagation();

        const envelopeId = document?.meeting
          ? document?.meeting?.envelope_id
          : document?.file?.signFileIntegration[0]?.envelope_id;

        // setLoadingToSign(true);
        setUrlToSign(
          `https://secure.d4sign.com.br/embed/viewblob/${envelopeId}?email=${user?.email}`,
        );

        setOpenDrawerToSign(true);
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingToSign(false);
        setLoadingModalViewer(false);
        setLoadingMinuteState(false);
      }
    },
    [user],
  );

  const getSignaturesSignedRequest = useCallback(async () => {
    try {
      setLoadingGetSignaturesSigned(true);
      let response: any;

      response = await getSignaturesSignedByCompanyId(
        user?.id as string,
        selectedCompany?.id as string,
        searchForSignaturesSigned,
        String(page),
      );

      if (response?.status === 200) {
        const allSignedDocs = response?.data;
        if (counselor && counselor?.length > 0) {
          const docsFilteredForCounselorName = allSignedDocs?.filter((d: any) =>
            d?.subscribers?.some((u: Subscribers) => u.name === counselor),
          );
          setListagemDocsAssinados(docsFilteredForCounselorName);
        } else {
          setListagemDocsAssinados(allSignedDocs);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingGetSignaturesSigned(false);
    }
  }, [
    selectedCompany?.id,
    user?.id,
    searchForSignaturesSigned,
    page,
    counselor,
  ]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    setLoadingGetSignaturesSigned(true);
    if (selectedCompany?.id && user?.id) {
      const delayDebounceFn = setTimeout(() => {
        getSignaturesSignedRequest();
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [selectedCompany?.id, user?.id, searchForSignaturesSigned, counselor]);

  const getSignaturesUnsignedRequest = useCallback(async () => {
    try {
      setLoadingGetSignaturesSigned(true);
      let response: any;

      response = await getSignaturesUnsignedByCompanyid(
        user?.id as string,
        selectedCompany?.id as string,
        searchForSignaturesSigned,
        String(page),
      );

      if (response?.status === 200) {
        const allUnsignedDocs = response?.data;

        if (counselor && counselor?.length > 0) {
          const docsFilteredForCounselorName = allUnsignedDocs?.filter(
            (d: any) =>
              d?.subscribers?.some(
                (u: Subscribers) =>
                  u.name.toUpperCase().includes(counselor.toUpperCase()) &&
                  u.isSigned === false,
              ),
          );
          setListagemDocsPendentes(docsFilteredForCounselorName);
          setLoadingGetSignaturesUnsigned(false);
        } else {
          const allUnsignedUsers = allUnsignedDocs?.map((u: any) => {
            const isSigned = u.subscribers?.map((us: any) => {
              if (us.id === user?.id) {
                return us.isSigned;
              }
              return null;
            });

            return {
              ...u,
              isSigned,
            };
          });

          setListagemDocsPendentes(allUnsignedUsers);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingGetSignaturesSigned(false);
    }
  }, [
    user?.id,
    selectedCompany?.id,
    searchForSignaturesSigned,
    page,
    counselor,
  ]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    setLoadingGetSignaturesSigned(true);
    if (selectedCompany?.id && user?.id) {
      const delayDebounceFn = setTimeout(() => {
        getSignaturesUnsignedRequest();
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [selectedCompany?.id, user?.id, searchForSignaturesSigned, counselor]);

  const getSignaturesToDocument = useCallback(
    async (id: string, event: any) => {
      event.stopPropagation();

      try {
        setLoadingGetToDocument(true);
        setOpenDrawerShowSignatures(true);

        let response: any;

        response = await getSignaturesById(id);

        if (response?.status === 200) {
          const subs = response?.data.subscribers;
          const subsFilteredSigned = subs?.filter(
            (sub: Subscribers) => sub?.isSigned === true,
          );
          const subsFilteredUnsigned = subs?.filter(
            (sub: Subscribers) => sub?.isSigned === false,
          );

          setListagemAssinados(subsFilteredSigned);
          setListagemPendentes(subsFilteredUnsigned);
          setMeetingId(response?.data.meeting_id);
          setFileId(response.data.file_id);

          if (response.data.meeting_id === null) {
            setIsDocumentInBase(true);
          } else {
            setIsDocumentInBase(false);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingGetToDocument(false);
      }
    },
    [],
  );

  const handleOpenModalViewer = useCallback(
    async (file: any) => {
      try {
        setOpenModalViewer(true);
        setLoadingModalViewer(true);

        const responseUrl = await fileApi.getFileUrl(
          file?.url,
          user?.id as string,
          selectedCompany?.id as string,
        );

        setUrlToViewer({
          url: responseUrl,
          fileType: file?.mimetype,
          fileId: file.id,
        });

        await createLogRequest({
          name: user?.name as string,
          user_id: user?.id as string,
          company_id: selectedCompany?.id as string,
          local: 'Assinaturas',
          action: 'Visualizou',
          description: `Visualizou o documento ${file?.original_name} na tela de assinaturas`,
        });
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingModalViewer(false);
      }
    },
    [selectedCompany?.id, user?.id, user?.name],
  );

  const getAllByCompanyId = useCallback(async () => {
    try {
      const response = await getSignaturesByCompanyId(
        selectedCompany?.id as string,
      );

      setTotalDocsPendents(response?.data.totalPendingDocuments);
      setTotalSubscriptions(response?.data.totalPendingSubscriptions);
    } catch (error) {
      console.log(error);
    }
  }, [selectedCompany?.id]);

  const getCounsolerByCompanyId = useCallback(async () => {
    try {
      const response = await getSignaturesUnsignedByDashboard(
        selectedCompany?.id as string,
      );

      setListagemConselheirosPendentes(response?.data);
    } catch (err) {
      console.log(err);
    }
  }, [selectedCompany?.id]);

  useEffect(() => {
    if (selectedCompany) {
      getAllByCompanyId();
      getCounsolerByCompanyId();
    }
  }, [selectedCompany]);

  async function handleSignatures() {
    const response = await getSignaturesUnsignedByCompanyid(
      user?.id as string,
      selectedCompany?.id as string,
      searchForSignaturesSigned,
      String(page),
    );

    if (response?.status === 200) {
      const allUnsignedDocs = response?.data;

      const allUnsignedUsers = allUnsignedDocs.map((u: any) => {
        const isSigned = u.subscribers.map((us: any) => {
          if (us.id === user?.id) {
            return us.isSigned;
          }
          return null;
        });

        return {
          ...u,
          isSigned,
        };
      });

      setListagemDocsPendentes(allUnsignedUsers);

      const subs = response?.data.subscribers;
      getAllByCompanyId();
      getCounsolerByCompanyId();
      getSignaturesSignedRequest();
      // eslint-disable-next-line no-restricted-syntax
      for (let s of subs) {
        if (s?.id === user?.id && s?.isSigned === true) {
          clearInterval(timerRef.current);
          setMinute({
            ...minute,
            signed: true,
          });
          setStateControlMinute(false);
          setLoadingMinuteState(false);
        }
      }
    }
  }

  useEffect(() => {
    if (stateControlMinute === true) {
      timerRef.current = setInterval(() => handleSignatures(), 3000);
      setLoadingMinuteState(true);
      setTimeout(() => {
        clearInterval(timerRef.current);
        setLoadingMinuteState(false);
      }, 12000);
    }
  }, [stateControlMinute]);

  const handleCloseDrawer = () => {
    setOpenDrawerShowSignatures(false);
    setStepDrawer('assinaturas');
    setLoadingToSign(false);
    setLoadingModalViewer(false);
    setLoadingMinuteState(false);
  };

  const handleChangeToPendents = () => {
    setStatusButton('pendentes');
    setSearchForSignaturesSigned('');
    setCounselor('');
  };

  const handleChangeToSignatures = () => {
    setStatusButton('assinados');
    setSearchForSignaturesSigned('');
    setCounselor('');
  };

  const handleSendReminder = useCallback(async () => {
    setDisabledButton(true);
    try {
      setLoadingGetToDocument(true);
      const signersToNotification = listagemPendentes?.map(s => ({
        name: s?.name,
        email: s?.email,
        id: s?.id,
      }));

      const data = {
        meetingId,
        fileId,
        isDocumentInBase,
        userId: user?.id,
        signers: signersToNotification,
      };
      const response = await sendNotificationRequest(data);

      if (response?.status === 201) {
        toast.success('Lembrete de assinatura reenviado com sucesso');
        setStepDrawer('successMessage');
      }
    } catch (err) {
      toast.error(
        'Ocorreu um erro ao reenviar o lembrete. Por favor, tente novamente mais tarde.',
      );
      console.error('handleSendReminder => ', err);
    } finally {
      setLoadingGetToDocument(false);
      setDisabledButton(false);
    }
  }, [fileId, isDocumentInBase, listagemPendentes, meetingId, user?.id]);

  const handleSelectCounselor = useCallback((name: string) => {
    setCounselor(name);
  }, []);

  const drawerToSign = () => {
    return (
      <Box width="95vw" height="100%">
        <DrawerToSign
          setOpenDrawerToSign={setOpenDrawerToSign}
          urlToSign={urlToSign}
          setMinute={setMinute}
          minute={minute}
          stateControlMinute={false}
          setStateControlMinute={setStateControlMinute}
        />
      </Box>
    );
  };

  const drawerShowSignatures = () => {
    return (
      <Box height="100%">
        <>
          {stepDrawer === 'assinaturas' && (
            <Box
              width="480px"
              padding="20px"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box>
                <Header>
                  <CloseRounded
                    sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                    onClick={handleCloseDrawer}
                  />
                  <span className="title">Assinatura</span>
                </Header>

                {loadingGetToDocument ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    mt="50px"
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    {listagemAssinados && listagemAssinados?.length > 0 && (
                      <Box>
                        <Typography mt="20px">
                          <CheckCircleRounded color="success" />
                          <span className="assinados">Quem assinou</span>
                        </Typography>
                        <Box width="100%" mt="20px">
                          {listagemAssinados?.map((signed: Subscribers) => (
                            <CardUser>
                              <Box
                                display="flex"
                                alignItems="center"
                                gap="10px"
                              >
                                {signed?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={signed?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(signed.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <span className="name">{signed.name}</span>
                              </Box>
                            </CardUser>
                          ))}
                        </Box>
                      </Box>
                    )}
                    {listagemPendentes && listagemPendentes?.length > 0 && (
                      <Box mt="20px">
                        <Typography>
                          <CheckCircleRounded color="error" />
                          <span className="pendentes">
                            Pendente de assinatura
                          </span>
                        </Typography>
                        <Box width="100%" mt="20px">
                          {listagemPendentes?.map((unSigned: Subscribers) => (
                            <CardUser>
                              <Box
                                display="flex"
                                alignItems="center"
                                gap="10px"
                              >
                                {unSigned?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={unSigned?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(unSigned.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <span className="name">{unSigned.name}</span>
                              </Box>
                            </CardUser>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </>
                )}
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'end',
                }}
              >
                <Button
                  variant="outlined"
                  sx={{ marginTop: '30px' }}
                  onClick={() => setStepDrawer('sendEmail')}
                >
                  Reenviar solicitação
                </Button>
              </Box>
            </Box>
          )}
        </>
        <>
          {stepDrawer === 'sendEmail' && (
            <Box
              width="480px"
              padding="20px"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box>
                <Header>
                  <CloseRounded
                    sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                    onClick={handleCloseDrawer}
                  />
                  <span className="title">Assinatura</span>
                </Header>

                {loadingGetToDocument ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    mt="50px"
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt="20px"
                    >
                      <Typography>
                        <span className="text">Quem receberá a mensagem</span>
                      </Typography>
                      <Tooltip
                        TransitionProps={{ style: { fontSize: '14px' } }}
                        title="O link de assinatura de um documento poderá ser reenviado nos seguintes intervalados de tempo: 1º em 1 min, 2º em 5 min, 3º em 30 min. E a partir disso o link poderá ser reenviado de 60 em 60 min."
                      >
                        <HelpOutlineIcon />
                      </Tooltip>
                    </Box>
                    <Box width="100%" mt="20px" mb="20px">
                      {listagemPendentes?.map(c => (
                        <CardUser>
                          <Box display="flex" alignItems="center" gap="10px">
                            {c?.avatar_url ? (
                              <Avatar sx={{ width: '40px' }}>
                                <img
                                  src={c?.avatar_url as string}
                                  alt="Foto de perfil"
                                  style={{ width: '100%' }}
                                />
                              </Avatar>
                            ) : (
                              <Avatar
                                {...stringAvatar(c.name!)}
                                sx={{ width: '40px' }}
                              />
                            )}
                            <span className="name">{c.name}</span>
                          </Box>
                        </CardUser>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box
                sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{ marginTop: '30px', color: '#ffffff' }}
                  onClick={handleSendReminder}
                  disabled={disabledButton}
                >
                  Enviar e-mail
                </Button>
              </Box>
            </Box>
          )}
        </>
        <>
          {stepDrawer === 'successMessage' && (
            <Box width="480px" padding="20px">
              <Header>
                <CloseRounded
                  sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                  onClick={handleCloseDrawer}
                />
                <span className="title">Assinatura</span>
              </Header>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                gap="10px"
                mt="50px"
              >
                <CheckCircleOutlineRounded
                  color="success"
                  sx={{ width: '66px', height: '66px' }}
                />
                <Typography display="flex" flexDirection="column">
                  <span className="title">
                    Assinatura solicitada com sucesso!
                  </span>
                  <span className="desc">
                    Os usuários serão solicitados para assinar o documento, e
                    receberão um e-mail de notificação.
                  </span>
                </Typography>
                <Button
                  variant="outlined"
                  sx={{ marginTop: '20px' }}
                  onClick={handleCloseDrawer}
                >
                  Ok, fechar
                </Button>
              </Box>
            </Box>
          )}
        </>
      </Box>
    );
  };

  return (
    <Container>
      {(user?.profile === 'UN1' && (
        <SectionSignatures>
          <Dashboard>
            {loadingMinuteState ? (
              <Box
                display="flex"
                alignItems="center"
                gap="10px"
                width="100%"
                justifyContent="center"
                margin="auto"
              >
                <CircularProgress size={30} />
              </Box>
            ) : (
              <>
                <span className="title"> Documentos</span>
                <Box display="flex" gap="20px" width="100%">
                  <Box className="docsPendents">
                    <span className="number">{totalDocsPendents}</span>
                    <Box display="flex" gap="10px">
                      <CloseRounded
                        color="error"
                        sx={{ width: '27px', height: '27px' }}
                      />
                      <span className="text">Documentos pendentes</span>
                    </Box>
                  </Box>
                  <Box className="signaturesPendents">
                    <span className="numberSignatures">
                      {totalSubscriptions}
                    </span>
                    <Box display="flex" gap="10px">
                      <PeopleOutlineRounded
                        sx={{ width: '27px', height: '27px', color: '#FFB547' }}
                      />
                      <span className="text">Assinaturas pendentes</span>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Dashboard>
          <ListagemPendencias>
            {loadingMinuteState ? (
              <Box
                display="flex"
                alignItems="center"
                gap="10px"
                width="100%"
                justifyContent="center"
                margin="auto"
              >
                <CircularProgress size={30} />
              </Box>
            ) : (
              <>
                <span className="title">Conselheiros pendentes</span>
                <Box width="100%" mt="10px">
                  {listagemConselheirosPendentes &&
                  listagemConselheirosPendentes?.length > 0 ? (
                    listagemConselheirosPendentes?.map(c => (
                      <CardUserToShowDocuments
                        onClick={() => handleSelectCounselor(c.name)}
                      >
                        <span>{c.name}</span>
                        <span>{c.quantidade} documentos</span>
                      </CardUserToShowDocuments>
                    ))
                  ) : (
                    <span className="subtitle">
                      Não há conselheiros com documentos pendentes de assinatura
                    </span>
                  )}
                </Box>
              </>
            )}
          </ListagemPendencias>
        </SectionSignatures>
      )) ||
        (user?.profile === 'UN2' && (
          <SectionSignatures>
            <Dashboard>
              <span className="title"> Documentos</span>
              <Box display="flex" gap="20px" width="100%">
                <Box className="docsPendents">
                  <span className="number">{totalDocsPendents}</span>
                  <Box display="flex" gap="10px">
                    <CloseRounded
                      color="error"
                      sx={{ width: '27px', height: '27px' }}
                    />
                    <span className="text">Documentos pendentes</span>
                  </Box>
                </Box>
                <Box className="signaturesPendents">
                  <span className="numberSignatures">{totalSubscriptions}</span>
                  <Box display="flex" gap="10px">
                    <PeopleOutlineRounded
                      sx={{ width: '27px', height: '27px', color: '#FFB547' }}
                    />
                    <span className="text">Assinaturas pendentes</span>
                  </Box>
                </Box>
              </Box>
            </Dashboard>
            <ListagemPendencias>
              <span className="title">Conselheiros pendentes</span>
              <Box width="100%" mt="10px">
                {listagemConselheirosPendentes &&
                listagemConselheirosPendentes?.length > 0 ? (
                  listagemConselheirosPendentes?.map(c => (
                    <CardUserToShowDocuments
                      onClick={() => handleSelectCounselor(c.name)}
                    >
                      <span>{c.name}</span>
                      <span>{c.quantidade} documentos</span>
                    </CardUserToShowDocuments>
                  ))
                ) : (
                  <span className="subtitle">
                    Não há conselheiros com documentos pendentes de assinatura
                  </span>
                )}
              </Box>
            </ListagemPendencias>
          </SectionSignatures>
        ))}
      <SectionFilters>
        <TabSignatures>
          <TabButton
            onClick={handleChangeToPendents}
            variant="text"
            active={statusButton === 'pendentes'}
          >
            Pendentes
          </TabButton>
          <TabButton
            variant="text"
            onClick={handleChangeToSignatures}
            active={statusButton === 'assinados'}
          >
            Assinados
          </TabButton>
        </TabSignatures>
        {(user?.profile === 'UN1' || user?.profile === 'UN2') && (
          <ButtonSelect>
            <TextField
              placeholder="Filtrar conselheiro"
              value={counselor}
              onChange={event => setCounselor(event.target.value)}
              InputProps={{
                style: {
                  height: '48px',
                  border: 'none',
                  width: '256px',
                  background: '#ffffff',
                  borderRadius: '4px',
                  padding: '9px 12px',
                },
                disableUnderline: true, //
                endAdornment: (
                  <IconButton>
                    <CloseRounded
                      sx={{ width: '20px' }}
                      onClick={() => setCounselor('')}
                    />
                  </IconButton>
                ),
              }}
              variant="standard"
            />
          </ButtonSelect>
        )}
        <SearchFilter>
          <TextField
            placeholder="Pesquisar por documento"
            fullWidth
            value={searchForSignaturesSigned}
            onChange={ev => setSearchForSignaturesSigned(ev.target.value)}
            InputProps={{
              style: {
                height: '48px',
                border: 'none',
                background: '#ffffff',
                borderRadius: '4px',
                padding: '9px 12px',
              },
              endAdornment: <SearchRounded />,
              disableUnderline: true, //
            }}
            variant="standard"
          />
        </SearchFilter>
      </SectionFilters>
      <SectionDocuments>
        <>
          {statusButton === 'pendentes' ? (
            loadingMinuteState || loadingGetSignaturesSigned ? (
              <Box
                display="flex"
                alignItems="center"
                gap="10px"
                width="100%"
                mt="150px"
                justifyContent="center"
              >
                <CircularProgress size={30} />
              </Box>
            ) : (
              <>
                {loadingMinuteState === false && (
                  <span className="title">
                    {`${
                      counselor === '' || counselor === null
                        ? 'Existem'
                        : `${counselor} tem`
                    } ${listagemDocsPendentes?.length} ${
                      listagemDocsPendentes?.length === 1
                        ? 'documento'
                        : 'documentos'
                    } ${
                      listagemDocsPendentes?.length === 1
                        ? 'pendente'
                        : 'pendentes'
                    }
                  de assinatura`}
                  </span>
                )}
                <>
                  {(listagemDocsPendentes?.map((document: any) => (
                    <CardDocument>
                      <Box
                        display="flex"
                        sx={{ cursor: 'pointer' }}
                        gap="10px"
                        onClick={() => handleOpenModalViewer(document?.file)}
                      >
                        <img src={PDF} alt="pdf" />
                        <span className="archive">
                          {document?.file?.original_name}
                        </span>
                      </Box>

                      <Box display="flex" gap="10px">
                        <React.Fragment key="right">
                          <Button
                            variant="outlined"
                            onClick={event =>
                              getSignaturesToDocument(document?.id, event)
                            }
                            sx={{
                              height: '42px',
                              fontWeight: '500',
                              fontSize: '15px',
                            }}
                          >
                            Ver Assinaturas
                          </Button>
                        </React.Fragment>

                        {document?.subscribers?.find(
                          (u: any) => u.id === user?.id && u.isSigned === true,
                        ) ? (
                          <Button
                            variant="outlined"
                            color="success"
                            sx={{
                              height: '42px',
                              fontWeight: '500',
                              fontSize: '15px',
                              width: '134px',
                            }}
                            endIcon={
                              <CheckCircleOutlineRounded color="success" />
                            }
                          >
                            Assinado
                          </Button>
                        ) : (
                          document?.subscribers?.find(
                            (u: any) => u.id === user?.id,
                          ) && (
                            <Button
                              variant="contained"
                              sx={{
                                height: '42px',
                                fontWeight: '500',
                                fontSize: '15px',
                              }}
                              onClick={event => handleToSign(document, event)}
                            >
                              Assinar
                            </Button>
                          )
                        )}
                      </Box>
                    </CardDocument>
                  )) &&
                    loadingModalViewer) ||
                  loadingToSign ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="10px"
                      width="100%"
                      justifyContent="center"
                      marginTop="166px"
                    >
                      <CircularProgress size={30} />
                    </Box>
                  ) : (
                    listagemDocsPendentes?.map((document: any) => (
                      <>
                        <CardDocument
                          onClick={() => handleOpenModalViewer(document?.file)}
                          sx={{ cursor: 'pointer' }}
                        >
                          <Box display="flex" gap="10px">
                            <img src={PDF} alt="pdf" />
                            <span className="archive">
                              {document?.file?.original_name}
                            </span>
                          </Box>

                          <Box display="flex" gap="10px">
                            <React.Fragment key="right">
                              <Button
                                variant="outlined"
                                onClick={event =>
                                  getSignaturesToDocument(document?.id, event)
                                }
                                sx={{
                                  height: '42px',
                                  fontWeight: '500',
                                  fontSize: '15px',
                                }}
                              >
                                Ver Assinaturas
                              </Button>
                            </React.Fragment>

                            {document?.subscribers?.find(
                              (u: any) =>
                                u.id === user?.id && u.isSigned === true,
                            ) ? (
                              <Button
                                variant="outlined"
                                color="success"
                                sx={{
                                  height: '42px',
                                  fontWeight: '500',
                                  fontSize: '15px',
                                  width: '134px',
                                }}
                                endIcon={
                                  <CheckCircleOutlineRounded color="success" />
                                }
                              >
                                Assinado
                              </Button>
                            ) : (
                              document?.subscribers?.find(
                                (u: any) => u.id === user?.id,
                              ) && (
                                <Button
                                  variant="contained"
                                  sx={{
                                    height: '42px',
                                    fontWeight: '500',
                                    fontSize: '15px',
                                    width: '134px',
                                  }}
                                  onClick={event =>
                                    handleToSign(document, event)
                                  }
                                >
                                  Assinar
                                </Button>
                              )
                            )}
                          </Box>
                        </CardDocument>
                      </>
                    ))
                  )}
                </>
              </>
            )
          ) : (
            <>
              <span className="title">Documentos assinados</span>
              {loadingModalViewer || loadingGetSignaturesSigned ? (
                <Box
                  display="flex"
                  alignItems="center"
                  gap="10px"
                  width="100%"
                  justifyContent="center"
                  marginTop="166px"
                >
                  <CircularProgress size={30} />
                </Box>
              ) : listagemDocsAssinados?.length > 0 ? (
                listagemDocsAssinados?.map((document: any) => (
                  <CardDocument
                    onClick={() => handleOpenModalViewer(document?.file)}
                  >
                    <Box display="flex" gap="10px">
                      <img src={PDF} alt="pdf" />
                      <span className="archive">
                        {document?.file?.original_name}
                      </span>
                    </Box>
                    <Box display="flex" gap="10px">
                      <Button
                        variant="outlined"
                        sx={{
                          height: '42px',
                          fontWeight: '500',
                          fontSize: '15px',
                        }}
                        onClick={event =>
                          getSignaturesToDocument(document?.id, event)
                        }
                      >
                        Ver Assinaturas
                      </Button>
                    </Box>
                  </CardDocument>
                ))
              ) : (
                <Box marginTop="10vh">
                  <InfoCard
                    title="Nenhuma assinatura encontrada!"
                    type="info"
                  />
                </Box>
              )}
            </>
          )}
        </>
      </SectionDocuments>
      <SwipeableDrawer
        open={openDrawerShowSignatures}
        onClose={() => setOpenDrawerShowSignatures(false)}
        onOpen={() => setOpenDrawerShowSignatures(true)}
        anchor="right"
      >
        {drawerShowSignatures()}
      </SwipeableDrawer>
      <SwipeableDrawer
        open={openDrawerToSign}
        onClose={() => setOpenDrawerToSign(true)}
        onOpen={() => setOpenDrawerToSign(true)}
        anchor="right"
      >
        {drawerToSign()}
      </SwipeableDrawer>

      <ViewerFile
        fileUrl={urlToViewer?.url}
        loading={loadingModalViewer}
        onClose={() => setOpenModalViewer(false)}
        open={openModalViewer}
        title="Visualizar documento"
        fileId={urlToViewer?.fileId}
      />
    </Container>
  );
};
